import { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { Button } from "../../components";
import Dashboard from "../../layout/Dashboard";
import { currencyFormat } from "../../utils/Formats";
import { BillingModal, FixedAlert } from "./Alerts";
import { PaymentCard } from "./Forms";
import PaymentProcessing from "./PaymentProcessing";
import { SessionContext } from "../../routes/DashboardRoute"

// this file can just be deleted later
const BillingAlerts = () => {
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [fixed, setFixed] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState("");
  const [session] = useContext(SessionContext);
  const { user, accounts } = session;
  const currentAccount = accounts[0];

  // só existe pra tela de sucesso ter dois cards diferentes
  const [dudState, setDudState] = useState(planFrame30806);

  // esse useeffect da trigger em si mesmo mas é so pra demonstração
  useEffect(() => {
      if (paymentStatus === 'loading') {
    setTimeout(() => {
      setPaymentStatus("");
    }, 5000);}
  }, [paymentStatus]);

  if (paymentStatus !== "") {
    return (
      <PaymentProcessing
        state={paymentStatus}
        data={{
          total: 67,
          PaymentInfo: dudState,
          name: currentAccount?.name || user?.name,
        }}
        onReturn={() => setPaymentStatus("")}
      />
    );
  }

  return (
    <Dashboard.Content style={{ maxWidth: "688px" }}>
      <Dashboard.Header
        returnButton={true}
        title="PlaceHoldin'"
        className="d-flex reverse-row"
      />
      <div className="mb-4 d-flex justify-content-between">
        <Link to="./../extradocs">Extra Documents</Link>
        <Link to="./../paymentupdate">Payment Data Update</Link>
        <Link to="./../history">Billing History</Link>
        <Link to="./../fiscaldata">Fiscal Data</Link>
        <Link to="./../changeplan">Change Plan</Link>
      </div>
      <Button
        variant="primary"
        onClick={() => setFixed(true)}
        className="mb-2 btn-block text-uppercase"
      >
        Alert - Expiração de Cartão
      </Button>
      <Button
        variant="secondary"
        onClick={() => setModal(true)}
        className="mb-2 btn-block text-uppercase"
      >
        Popup - Sem Documentos
      </Button>
      <Button
        variant="primary"
        onClick={() => setModal2(true)}
        className="mb-2 btn-block text-uppercase"
      >
        Popup - Problema na Cobrança
      </Button>
      <Button
        variant="secondary"
        onClick={() => setPaymentStatus("loading")}
        className="mb-2 btn-block text-uppercase"
      >
        Processing - Loading
      </Button>
      <Button
        variant="primary"
        onClick={() => {
          setPaymentStatus("success");
          setDudState(planFrame30806);
        }}
        className="mb-2 btn-block text-uppercase"
      >
        Processing - Success (Plan)
      </Button>
      <Button
        variant="secondary"
        onClick={() => {
          setPaymentStatus("success");
          setDudState(docsFrame30806);
        }}
        className="mb-2 btn-block text-uppercase"
      >
        Processing - Success (Extra Documents)
      </Button>
      <Button
        variant="primary"
        onClick={() => setPaymentStatus("failure")}
        className="mb-2 btn-block text-uppercase"
      >
        Processing - Failure
      </Button>

      {/* Alert - Expiração de Cartão*/}
      <FixedAlert
        show={fixed}
        onClose={() => setFixed(false)}
        text="Seu plano será alterado de %Plano Pago% para Free em 15/09/24. Após essa data, a quantidade de documentos será reduzida de 200 para 5."
      />

      {/* Popup - Sem Documentos */}
      <BillingModal
        title="Sem documentos disponíveis para envio"
        description="Você consumiu 100% dos documentos disponíveis no seu plano, para enviar novos documentos, altere seu plano ou compre documentos extras."
        progress={100}
        renew="10 de setembro de 2024"
        show={modal}
        onClose={() => setModal(false)}
      >
        <div className="billing-modal-buttons">
          <Button variant="border">esperar renovação</Button>
          <Button variant="primary">Opções de Plano</Button>
        </div>
      </BillingModal>

      {/* Popup - Problema na Cobrança */}
      <BillingModal
        title="Problema na cobrança!"
        description="Não conseguimos efetuar a cobrança no seu cartão de crédito, atualize os dados do seu cartão para continuar usufruindo dos benefícios do seu plano"
        show={modal2}
        onClose={() => setModal2(false)}
      >
        <div className="billing-modal-buttons">
          <Button variant="border">Atualizar depois</Button>
          <Button variant="primary">Atualizar agora</Button>
        </div>
      </BillingModal>
    </Dashboard.Content>
  );
};

export default BillingAlerts;

const planFrame30806 = (
  <PaymentCard
    className="w-100 info-card"
    topcontent={
      <div className="w-100">
        <h2>Plano Standard</h2>
        <p className="plan-price">
          R$ 39,00<span>/mês</span>
        </p>
        <p>• 50 documentos por mês </p>
        <div className="change-plan-row">
          <p>• {currencyFormat(1)} por documento adicional</p>
        </div>
      </div>
    }
    middlecontent={
      <>
        <div>
          <p>
            Cupom aplicado:{" "}
            <span className="fw-500">FEBAO10</span>
          </p>
        </div>
        <div className="payment-summaryRow">
          <p className="payment-summaryRow-title">Resumo de valores</p>
          <p className="extraDocs-summaryRow-date">1º pagamento em 29/08/24</p>
        </div>
        <div>
          <p>Plano Standard</p>
          <p>{currencyFormat(39)}</p>
        </div>
        <div>
          <p>Cupom</p>
          <div className="fw-500">{currencyFormat(-10)}</div>
        </div>
      </>
    }
    total={29}
  />
);

const docsFrame30806 = (
  <PaymentCard
    className="w-100 info-card"
    topcontent={
      <div className="w-100">
            <h2>Documentos extras</h2>
            <p>Valor unitário {currencyFormat(1)}</p>
          <div className="plan-price">50 un</div>
      </div>
    }
    middlecontent={
      <>
        <div>
          <p>
            Cupom aplicado:{" "}
            <span className="fw-500">FEBA20</span>
          </p>
        </div>
        <div className="payment-summaryRow">
          <p className="payment-summaryRow-title">Resumo de valores</p>
          <p className="extraDocs-summaryRow-date">29 de setembro de 2024</p>
        </div>
        <div className="payment-amountBox">
              <p>Documentos extras</p>
              <div className="payment-amountBox-inner">
                <div>Quant. 50</div>
                <div className="fw-500">
                  {currencyFormat(50)}
                </div>
              </div>
            </div>
        <div>
          <p>Cupom</p>
          <div className="fw-500">{currencyFormat(-20)}</div>
        </div>
      </>
    }
    total={30}
  />
);
